import { render, staticRenderFns } from "./ManagementShipping.vue?vue&type=template&id=f525e72e&scoped=true"
import script from "./ManagementShipping.vue?vue&type=script&lang=js"
export * from "./ManagementShipping.vue?vue&type=script&lang=js"
import style0 from "./ManagementShipping.vue?vue&type=style&index=0&id=f525e72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f525e72e",
  null
  
)

export default component.exports